<template>
    <rkm-form
        ref="Form"
        show-legend
    >

        <rkm-area
            type="fieldset"
            title="Condição de Saúde em Geral"
        >
            <FormCondicao
                :data="data"
            />
        </rkm-area>

        <rkm-area
            type="fieldset"
            title="Cidadão em situação de rua"
        >
            <FormSituacaoRua
                :data="data"
            />
        </rkm-area>
    </rkm-form>
</template>

<script>

// Filters
import formats from '@/filters/formats'

// Mixins
import { repository, object } from '@/mixins'

// Components
import FormCondicao from './components/condicao/Form.vue'
import FormSituacaoRua from './components/situacao-rua/Form.vue'

export default {
    components: {
        FormCondicao,
        FormSituacaoRua,
    },
    data: () => ({
        model: null,
        form: null,
    }),
    methods: {
        async validate() {

            return this.$refs.Form.validate()
        }
    },
    mixins: [ repository, object, formats, ],
    props: {
        data: { type: Object, required: false },
    }
}

</script>